import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Utils } from '@app/shared/services/utils.service';
import { wrapError } from '@app/utils/rxjs';
import { mergeMap, Observable } from 'rxjs';
import { DeviceSeries } from '../interfaces/allowed-device';
import { UserLevel } from '../models/user-level';

@Injectable({
  providedIn: 'root',
})
export class DeviceSeriesRepository {
  constructor(
    private http: HttpClient,
    private utils: Utils
  ) {}

  create(deviceSeries: DeviceSeries): Observable<void> {
    return this.utils.routeBasedApiUrl('/deviceSeries', UserLevel.SystemAdmin).pipe(
      mergeMap((url) => this.http.post<void>(url, deviceSeries)),
      wrapError('device-series-repository:create')
    );
  }

  delete(id: number): Observable<void> {
    return this.utils.routeBasedApiUrl(`/deviceSeries/${id}`, UserLevel.SystemAdmin).pipe(
      mergeMap((url) => this.http.delete<void>(url)),
      wrapError('device-series-repository:delete')
    );
  }

  list(): Observable<DeviceSeries[]> {
    return this.utils.routeBasedApiUrl('/deviceSeries', UserLevel.SystemAdmin).pipe(
      mergeMap((url) => this.http.get<DeviceSeries[]>(url)),
      wrapError('device-series-repository:list')
    );
  }

  listForEnterprise(): Observable<DeviceSeries[]> {
    return this.utils.apiUrl('/deviceSeries').pipe(
      mergeMap((url) => this.http.get<DeviceSeries[]>(url)),
      wrapError('device-series-repository:list-for-enterprise')
    );
  }

  update(id: number, deviceSeries: DeviceSeries): Observable<void> {
    return this.utils.routeBasedApiUrl(`/deviceSeries/${id}`, UserLevel.SystemAdmin).pipe(
      mergeMap((url) => this.http.put<void>(url, deviceSeries)),
      wrapError('device-series-repository:update')
    );
  }
}
